import './menstrual-culture-encume-poster.css'
import posterImg from '../../../assets/img/cultura-menstrual/Cartel programa 1er EnCuMe.png'

export default function MenstrualCultureEncumePoster() {
  return (
    <section className='menstrual-culture-encume-poster'>
      <div className='menstrual-culture-encume-poster__container'>
        <img
          src={posterImg}
          alt='Cartel del programa del 1er Encuentro de Cultura Menstrual (EnCuMe)'
          className='menstrual-culture-encume-poster__image'
        />
      </div>
    </section>
  )
}
